import { Injectable } from "@angular/core";
import { PsnbUserInfo, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSCreateUserCodeService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllUsers();
    }

    getAllUsers() {
        return this.powerSupplyService.getAllUsers().pipe(map(result => result));
    }

    psCreateUser(model: PsnbUserInfo) {
        return this.powerSupplyService.createUser(model).pipe(map(result => result));
    }

    psUpdateUser(model: PsnbUserInfo) {
        return this.powerSupplyService.updateUser(model).pipe(map(result => result));
    }

    psdeleteUserType(id: number) {
        return this.powerSupplyService.deleteUser(id).pipe(map(result => result));
    }
}
